import { render, staticRenderFns } from "./tv-vip.vue?vue&type=template&id=023296a0&lang=pug&"
import script from "./tv-vip.vue?vue&type=script&lang=js&"
export * from "./tv-vip.vue?vue&type=script&lang=js&"
import style0 from "./tv-vip.vue?vue&type=style&index=0&id=023296a0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports